import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceOverviewCard = ({ title, status, lastUpdated, dueDate, description, icon, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'compliant':
        return 'text-success bg-success/10 border-success/20';
      case 'attention':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'overdue':
        return 'text-error bg-error/10 border-error/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'compliant':
        return 'CheckCircle';
      case 'attention':
        return 'AlertTriangle';
      case 'overdue':
        return 'AlertCircle';
      default:
        return 'Clock';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
        <div className={`px-3 py-1 rounded-full border text-sm font-medium flex items-center gap-2 ${getStatusColor(status)}`}>
          <Icon name={getStatusIcon(status)} size={14} />
          {status === 'compliant' ? 'Compliant' : status === 'attention' ? 'Attention Required' : 'Overdue'}
        </div>
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Last Updated:</span>
          <span className="text-foreground">{lastUpdated}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Next Due Date:</span>
          <span className="text-foreground font-medium">{dueDate}</span>
        </div>
      </div>

      <button
        onClick={onViewDetails}
        className="w-full bg-muted hover:bg-muted/80 text-foreground py-2 px-4 rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
      >
        <Icon name="Eye" size={16} />
        View Details
      </button>
    </div>
  );
};

export default ComplianceOverviewCard;